import { createFileRoute } from '@tanstack/react-router';
import { healthConsoleSearchSchema } from '@/features/metric-hub/health/console-search';
import { HealthConsolePage } from '@/features/metric-hub/health/HealthConsolePage';

/**
 * Health console — every governed metric's computed health, filterable.
 * Filters live in the URL (`?state=failing&area=OPS`).
 */
export const Route = createFileRoute('/_authed/metric-hub/health')({
  validateSearch: healthConsoleSearchSchema,
  component: HealthRoute,
});

function HealthRoute() {
  const search = Route.useSearch();
  return <HealthConsolePage search={search} />;
}
